export default __webpack_public_path__ + "static/media/adjustment.91829f06.svg";